import React from "react"
import { useSelector } from "react-redux"
import { getClockFormat } from "reduxSlices/currentSettingsSlice"
import { isEmpty } from "lodash-es"
import { auditItemDetailsComponent } from "utils/auditHelper"
import { orgLocalDateTimeByClockFormat } from "utils/dateHelpers"
import { auditShape } from "utils/propTypeShapes"
import ItemRow from "shared/ItemRow"
import { ImpersonationBadge } from "shared/badges"
import * as UserActionAuditItemDetails from "views/Users/ShowUser/UserTabs/ActionsTab/AuditItem/AuditItemDetails"
import RelatedItemLink from "./RelatedItemLink"

const FALLBACK_USER_NAME = "a user"

const AuditItem = ({ audit }) => {
  const {
    form, formSubmissionSlug, impersonator, user,
  } = audit
  const { fullName } = user
  const userName = fullName || FALLBACK_USER_NAME

  const AuditItemDetailsComponent = auditItemDetailsComponent(audit, UserActionAuditItemDetails)
  const clockFormat = useSelector(getClockFormat)

  return (
    <>
      <ItemRow
        itemRowHeaderContentClassName="flex flex-col-reverse text-sm lg:flex-row gap-4"
        itemRowHeaderContent={(
          <>
            {
              !isEmpty(form)
              && (
                <div className="lg:min-w-[135px] lg:max-w-[135px]">
                  <RelatedItemLink form={form} formSubmissionSlug={formSubmissionSlug} />
                </div>
              )
            }
            <div className="w-half">
              {
                !isEmpty(impersonator) && (
                  <ImpersonationBadge className="mb-1" text={`Impersonating ${userName}`} />
                )
              }
              <AuditItemDetailsComponent audit={audit} />
            </div>
            <div className="text-dark text-xs shrink-0 lg:ml-auto">
              {orgLocalDateTimeByClockFormat(audit.createdAt, clockFormat)}
            </div>
          </>
        )}
      />
    </>
  )
}

AuditItem.propTypes = {
  audit: auditShape.isRequired,
}

export default AuditItem
